export default __webpack_public_path__ + "static/ScottRumph-dfa54c78db8a72a43ef56eb69f50b3e2.jpg";